import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import guessedRiddleString from "../../constants/GUESSED_RIDDLE_STRINGS";
import GuessedRiddleNavigation from "./guessed-riddle-navigation";
import {setActiveRiddle} from "../../ducks/duck-screen";
import {getImageFromRiddle} from "../../helpers/cloud-function/riddle-image";

function GuessedRiddleNavigationContainer(props) {
	const { gameType,
		currentRiddleRange,
		activeLogoIndex,
		resetScrollPosition,
		userRiddles,
		stringIndex,
		setActiveRiddle } = props;

	function navigationClick(riddle, index){
		resetScrollPosition();
		setActiveRiddle(riddle, index);
	}

	const currentLevelRiddleList = userRiddles[gameType][currentRiddleRange];
	if(currentLevelRiddleList){
		const previousRiddle = currentLevelRiddleList[activeLogoIndex-1];
		const nextRiddle = currentLevelRiddleList[activeLogoIndex+1];

		if(previousRiddle){
			previousRiddle.imgWithUrl = getImageFromRiddle(previousRiddle);
			previousRiddle.indexInRiddleList = activeLogoIndex-1;
		}
		if(nextRiddle){
			nextRiddle.imgWithUrl = getImageFromRiddle(nextRiddle);
			nextRiddle.indexInRiddleList = activeLogoIndex+1;
		}

		return (
			<GuessedRiddleNavigation {...props}
			                         navigationClick={navigationClick}
			                         previousRiddle={previousRiddle}
			                         nextRiddle={nextRiddle}
			                         successText={guessedRiddleString[(stringIndex-1)%12]}
			/>
		);
	} else {
		return <div/>
	}



}

GuessedRiddleNavigationContainer.propTypes = {
	isLoading: PropTypes.bool.isRequired,

	currentRiddleRange: PropTypes.string.isRequired,
	gameType: PropTypes.string.isRequired,
	stringIndex: PropTypes.number.isRequired,

	userRiddles: PropTypes.object.isRequired,

	setActiveRiddle: PropTypes.func.isRequired,
	resetScrollPosition: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
	const gameType = state.gameReducer.gameType;
	return {
		currentRiddleRange: state.screenReducer.currentRiddleRange,
		activeLogoIndex: state.screenReducer.activeLogoIndex,
		gameType,
		userRiddles: state.gameReducer.userRiddles,
	};
}

export default connect(mapStateToProps,
	{ setActiveRiddle } )(GuessedRiddleNavigationContainer);
